<label class="mbm-checkbox" [class.mbm-checkbox-disabled]="disabled()">
  <input class="mbm-checkbox-input" type="checkbox"
    [checked]="checked()" [disabled]="disabled()" (change)="onCheckboxChange($event)" />
  <span class="mbm-checkbox-control" aria-hidden="true"></span>
  <ng-content></ng-content>
</label>
